<script>
import Layout from "@/views/layouts/main.vue";
import ProjectInfo from "@/views/pages/project/sale/project_info.vue";
import apiEndpoints from "@/services/apiEndpoints";
import CommonTableComponent from "@/components/table.vue";
import pagination from "@/mixins/pagination";
import tableSearch from "@/mixins/tableSearch";
import router from "@/mixins/router";
import SelectVehicleModal from "@/views/pages/project/sale/instruction/modals/SelectVehicleModal.vue";
import ChooseQualificationModal from "@/views/pages/project/sale/instruction/modals/ChooseQualificationModal.vue";
import ChooseImplementByFacilityModal
  from "@/views/pages/project/sale/instruction/modals/ChooseImplementByFacilityModal.vue";
import ChooseWasteOrServiceModal from "@/views/pages/project/sale/instruction/modals/ChooseWasteOrServiceModal.vue";
import DropZoneModal from "@/components/Common/DropZoneModal.vue";
import SelectTransportContractModal from "@/views/pages/project/sale/instruction/modals/SelectTransportContractModal";
import SelectTreatmentContractModal from "@/views/pages/project/sale/instruction/modals/SelectTreatmentContractModal";
import AttachmentFiles from "@/views/pages/project/sale/instruction/attachment_files.vue";
import ContractVendorsInfo from "@/views/pages/project/sale/instruction/contract_vendors_info.vue";
import TransportContracts from "@/views/pages/project/sale/instruction/transport_contracts.vue";
import TreatmentContracts from "@/views/pages/project/sale/instruction/treatment_contracts.vue";
import SearchDataUserModal from "@/views/pages/project/sale/instruction/modals/SearchDataUserModal.vue";
import DatePicker from 'vue2-datepicker';
import sweetAlert from "@/mixins/sweetAlert";
import {mapGetters} from "vuex";
import DeviceDetectionMixin from "@/mixins/DeviceDetectionMixin";
import user from "@/mixins/user";
import ModalWorkHistory from "@/views/pages/daily_reports/modals/ModalWorkHistory.vue";

export default {
  mixins: [pagination, tableSearch, router, sweetAlert, DeviceDetectionMixin, user],
  components: {
    Layout,
    ProjectInfo,
    CommonTableComponent,
    SelectTreatmentContractModal,
    SelectTransportContractModal,
    SelectVehicleModal,
    ChooseQualificationModal,
    ChooseImplementByFacilityModal,
    DropZoneModal,
    ChooseWasteOrServiceModal,
    DatePicker,
    AttachmentFiles,
    ContractVendorsInfo,
    TransportContracts,
    TreatmentContracts,
    SearchDataUserModal,
    WorkOrderTypeBadge: () => import('@/components/Common/WorkOrderTypeBadge.vue'),
    ModalWorkHistory,
  },
  async created() {
    this.getProject();
    if (this.isUpdate) {
      this.getOrder();
    } else {
      if(this.base_workorder_id){
        // ベースにする作業指示を検索
              this.isLoading = true;

      const url = apiEndpoints.projects_sales_work_orders_detail(this.projectId, this.base_workorder_id);
      let params = {
        tmp: this.tmp,
        copy: this.copy,
      };
      const {status, data} = await this.$http.getWithLoading(url, params);
      let baseData = data.result.work_order;
      // this.data = baseData;
      this.form = {
        name : baseData.name,
        number_of_staffs_delivered: baseData.number_of_staffs_delivered,
        rental_and_special_items_comment:baseData.rental_and_special_items_comment,
        work_detail_and_safety_measure_comment:baseData.work_detail_and_safety_measure_comment,
        product_sales_comment:baseData.product_sales_comment,
        standard_working_hours:baseData.standard_working_hours,
        standard_travel_hours:baseData.standard_travel_hours,
        standard_unloading_hours:baseData.standard_unloading_hours,
        standard_total_hours:baseData.standard_total_hours,
        mixed_loading_kbn:baseData.mixed_loading_kbn,
        planned_start_date:baseData.planned_start_date,
        remarks:baseData.remarks,
        is_reservation_rental_containers:baseData.is_reservation_rental_containers,
        discharger_site_user_email:baseData.discharger_site_user_email,
        qualifications_by_work_order: baseData.qualifications_converted,
        implements_by_work_order: baseData.implements_converted,
        contracts_by_work_order: [],
        checklists_by_work_order: baseData.checklists_converted,
        car_types_by_work_order: [],
        wastes_or_services_by_work_order: [],
        files: [],
        rental_and_special_items_comment: baseData.rental_and_special_items_comment ?? '',
        work_detail_and_safety_measure_comment: baseData.work_detail_and_safety_measure_comment ?? '',
        planned_start_date: baseData.planned_start_date,
      }
      this.$nextTick(() => {
        this.reRenderModal('key_files');
      })

      delete this.form.qualifications_converted;
      delete this.form.implements_converted;
      delete this.form.contracts_converted;
      delete this.form.checklists_converted;
      delete this.form.cars_converted;
      delete this.form.wastes_or_services_converted;
      delete this.form.attachments;
      delete this.form.history_lastest;

      this.isLoading = false;
      }else{
      this.dataLoaded = true;
      this.form.name = "（"+this.workOrderType+"）";
      this.form.work_detail_and_safety_measure_comment =
                     " ①（作業概要）"
                      +"<br>②（荷姿） ドラムなど"
                      +"<br> ③（現場担当者）○○課○○様"
                      +"<br> ④（連絡先） TEL"
                      +"<br> ⑤（立会いの有無） 有り ・ 無し"
                      +"<br> ⑥（入場方法） 8:30 前入場禁止"
                      +"<br> ⑦（作業） 作業詳細、 積込み方法を記載（だれが、どのように）"
                      +"<br> ⑧（安全対策） 注意事項等"
                      +"<br> ⑨（退場方法） 返却物、報告等"
                      +"<br> ⑩（予定数量）"
                      +"<br> ⑪（備考） あれば";
      }
    }
  },
  data() {
    return {
      activeTabIndex: Number(this.$route.query.activeTabIndex)
        ? Number(this.$route.query.activeTabIndex)
        : this.$constant.pages.project.sales.waste.tabIndex,
      isLoading: false,
      tools: [],
      base_workorder_id: this.$route.query.baseWorkOrderId || '',
      data: null,
      form: {
        name: "",
        qualifications_by_work_order: [],
        implements_by_work_order: [],
        contracts_by_work_order: [],
        checklists_by_work_order: [],
        car_types_by_work_order: [],
        number_of_staffs_delivered: 1,
        rental_and_special_items_comment: "",
        is_reservation_rental_containers: 0,
        work_detail_and_safety_measure_comment: "",
        standard_working_hours: "",
        standard_travel_hours: "",
        standard_unloading_hours: "",
        standard_total_hours: "",
        mixed_loading_kbn: "1",
        planned_start_date: "",
        remarks: "",
        product_sales_comment: "",
        files: [],
        zz_work_order_type_id: this.$route.query.type || '',
        wastes_or_services_by_work_order: [],
        user_approval: null,
        comment: '',
        discharger_site_user_email: ''
      },
      user_approval: '',
      projectInfos: null,
      errors: {},
      key_qualifications: 1,
      key_implements: 1,
      key_cars: 1,
      key_wastes_or_services: 1,
      key_files: 1,
      ckeditorOptions: this.$ckeditor,
      role: [],
      dataLoaded: false,
      reservedIds: [],
      isCantApprove: false,
    };
  },
  methods: {
    async getProject() {
      this.isLoading = true;

      const url = apiEndpoints.projects_sales.replace(
        ":id",
        this.$route.params.id
      );
      const sendApiProject = await this.$http.get(url, {tmp: this.tmp});
      const {status, data} = sendApiProject;

      if (status) {
        this.projectInfos = data.result;
      }

      this.isLoading = false;
    },
    async getOrder() {
      this.isLoading = true;

      const url = apiEndpoints.projects_sales_work_orders_detail(this.projectId, this.workOrderId);
      let params = {
        tmp: this.tmp,
        copy: this.copy,
      };
      if (this.dailyReportId) {
        params.daily_report_id = this.dailyReportId;
      }
      const {status, data} = await this.$http.getWithLoading(url, params);

      this.isLoading = false;
      if (status) {
        if (this.tmp && this.tmp != 0) {
          // 一時保存状態の更新、承認時はこちら
          this.mappingDataTmp(data.result)
          this.isCantApprove = data.result.isCantApprove;
        } else {
          // 新規更新申請はこちら
          this.mappingData(data.result.work_order)
        }
        this.role = data.result.role;
        this.dataLoaded = true;
        this.reservedIds = data.result.reservedIds
        return;
      }
      this.$router.push({
        name: 'projects.sales',
        query: {
          activeTabIndex: this.$constant.pages.project.sales.instruction.tabIndex
        }
      })
    },
    mappingDataTmp(data) {
      this.form = data.work_order.json
      // this.form.planned_start_date = this.form.planned_start_date ? new Date(this.form.planned_start_date) : '';

      this.form.rental_and_special_items_comment = data.work_order.json.rental_and_special_items_comment ?? '';
      this.form.work_detail_and_safety_measure_comment = data.work_order.json.work_detail_and_safety_measure_comment ?? '';
      if (!this.form.hasOwnProperty('is_reservation_rental_containers')) {
        this.form.is_reservation_rental_containers = 0;
      }

      if (data.work_order.work_order_id) {
        data.work_order.workflow_histories = data.work_order.workflow_histories_by_work_order;
      }

      this.data = data.work_order;
      this.$nextTick(() => {
        this.reRenderModal('key_files');
      })
    },
    mappingData(data) {
      this.data = data;
      this.form = {
        ...data,
        qualifications_by_work_order: data.qualifications_converted,
        implements_by_work_order: data.implements_converted,
        contracts_by_work_order: data.contracts_converted,
        checklists_by_work_order: data.checklists_converted,
        car_types_by_work_order: data.cars_converted,
        wastes_or_services_by_work_order: data.wastes_or_services_converted,
        files: data.attachments,
        rental_and_special_items_comment: data.rental_and_special_items_comment ?? '',
        work_detail_and_safety_measure_comment: data.work_detail_and_safety_measure_comment ?? '',
        planned_start_date: data.planned_start_date,
      }
      this.$nextTick(() => {
        this.reRenderModal('key_files');
      })

      delete this.form.qualifications_converted;
      delete this.form.implements_converted;
      delete this.form.contracts_converted;
      delete this.form.checklists_converted;
      delete this.form.cars_converted;
      delete this.form.wastes_or_services_converted;
      delete this.form.attachments;
    },
    onChangeDataQualification(data) {
      this.$set(this.form, "qualifications_by_work_order", data);
    },
    onChangeDataImplements(data) {
      this.$set(this.form, "implements_by_work_order", data);
    },
    onChangeWastesOrServices(data) {
      const dataMapping = this.$_.cloneDeep(data)
      dataMapping.forEach((wasteOrService, index) => {
        const indexMatch = this.form.wastes_or_services_by_work_order.findIndex(x => {
          if (x.disposal_sites_by_waste_id) {
            return x.cd.toString() === wasteOrService.cd.toString() && x.disposal_sites_by_waste_id.toString() === wasteOrService.disposal_sites_by_waste_id.toString()
          }

          return x.cd.toString() === wasteOrService.cd.toString();
        })
        if (indexMatch !== -1) {
          dataMapping[index] = {...this.form.wastes_or_services_by_work_order[indexMatch]}
        }
      });
      this.$set(this.form, "wastes_or_services_by_work_order", dataMapping);
    },
    onChangeCars(data) {
      this.$set(this.form, "car_types_by_work_order", data);
    },
    onChangeTransportContract(transportContract) {
      const currentContractsByWorkOrder = [...this.form.contracts_by_work_order];
      let index = currentContractsByWorkOrder.findIndex(contract => !!contract.transport_contract_cd)
      if(index > -1){
        currentContractsByWorkOrder[index] = {...transportContract}
      } else {
        currentContractsByWorkOrder.push({...transportContract})
      }
      this.$set(this.form, "contracts_by_work_order", [...currentContractsByWorkOrder]);
    },
    onChangeTreatmentContract(treatmentContract) {
      const currentContractsByWorkOrder = [...this.form.contracts_by_work_order];
      let index = currentContractsByWorkOrder.findIndex(contract => !!contract.treatment_contract_cd)
      if (index > -1) {
        currentContractsByWorkOrder[index] = {...treatmentContract}
      } else {
        currentContractsByWorkOrder.push({...treatmentContract})
      }
      this.$set(this.form, "contracts_by_work_order", [...currentContractsByWorkOrder]);
    },
    onCalculateTotalTime() {
      const sum = (parseFloat(this.form.standard_working_hours) || 0) +
        (parseFloat(this.form.standard_unloading_hours) || 0) +
        (parseFloat(this.form.standard_travel_hours) || 0)
      this.form.standard_total_hours = sum
    },
    async submit(action) {
      const cfMessage = this.getConfirmMessage(action);
      const isClear = action === this.$constant.workflowStatus.clear;

      this.confirm(
        '',
        '',
        cfMessage.confirm,
        isClear ? 'warning' : 'info',
        isClear ? '削除' : 'OK',
        isClear ? '戻る' : 'キャンセル'
      ).then(async (result) => {
        if (result.isConfirmed) {
          if (action === this.$constant.workflowStatus.submit
             || action === this.$constant.workflowStatus.draft
          ) {
            await this.createOrUpdate(action, cfMessage);
          } else {
            await this.updateStatueWorkflow(action, cfMessage);
          }
        }
      });
    },
    getConfirmMessage(action) {
      let message = {
        confirm: '',
        success: ''
      };
      if (action === this.$constant.workflowStatus.submit) {
        message.confirm = '作業指示登録を申請してもよろしいですか。';
        message.success = '作業指示登録を申請しました。';
      } else if (action === this.$constant.workflowStatus.back_before_approved) {
        message.confirm = '作業指示登録を取り消してもよろしいですか。';
        message.success = '作業指示登録を取り消しました';
      } else if (action === this.$constant.workflowStatus.approve) {
        message.confirm = '作業指示登録を承認してもよろしいですか。';
        message.success = '作業指示登録を承認しました';
      } else if (action === this.$constant.workflowStatus.back_submit) {
        message.confirm = '作業指示登録を差し戻してもよろしいですか。';
        message.success = '作業指示登録を差し戻しました';
      } else if (action === this.$constant.workflowStatus.clear) {
        message.confirm = '作業指示登録を申請削除してもよろしいですか。';
        message.success = '作業指示登録の申請を削除しました';
      } else if (action === this.$constant.workflowStatus.draft) {
        message.confirm = '作業指示情報を下書き保存してもよろしいですか。';
        message.success = '作業指示登録を下書き保存しました。';
      }
      return message;
    },
    confirmDraftDelete(){
      this.confirm(
        '',
        '',
        '下書きは完全に削除されます。削除しますか？',
        'warning',
        '削除',
        '戻る',
      ).then(async (result) => {
        if (result.isConfirmed) {
            await this.deleteDraft();
        }
      });
    },
    async deleteDraft(){
      const url = apiEndpoints.work_order_delete_draft(this.projectId, this.data.id); // tempのid
      let params = {...this.form,} // 登録されたファイルの削除に必要
      const {status, data, code} = await this.$http.delete(url, params); // WorkOrderController->deleteDraft
      // 削除後は一覧画面に戻る
      if(status){
        if(data.result.status){
          this.successToast('下書きを削除しました。', false, 3000);
          this.$router.push({
            name: 'projects.sales',
            query: {
              activeTabIndex: this.$constant.pages.project.sales.instruction.tabIndex
            }
          });
        }
      }else{
        return this.errorToast('下書きの削除に失敗しました。');
      }
    },
    async updateStatueWorkflow(action, cfMessage) {
      this.errors = {};
      let params = {
        ...this.form,
        action: action,
        link: this.fullURL
      };
      const url = apiEndpoints.work_order_update_status_workflow(this.projectId, this.workOrderId)
      const {status, data, code, result} = await this.$http.post(url, params);
      if (status && data.result.status) {
        this.successToast(cfMessage.success, false, 3000);
        this.$router.push({
          name: 'projects.sales',
          query: {
            activeTabIndex: this.$constant.pages.project.sales.instruction.tabIndex
          }
        })
        return;
      }
      if (this.$helpers.isDisplayFormError(code)) {
        this.errors = data.errors;
        return this.$nextTick(() => {
          this.scrollIntoError();
        });
      } else if (this.$helpers.isDisplayErrorInLocalComponent(code)) {
        return this.errorToast(data.message);
      }
    },
    async createOrUpdate(action, cfMessage) {
      this.errors = {};
      let params = {
        ...this.form,
        case_id: this.projectId,
        // planned_start_date: this.form.planned_start_date ? this.$moment(this.form.planned_start_date).format("YYYY-MM-DD") : '',
        tmp: this.tmp,
        action: action,
        link: this.fullURL
      };
      let isUpdateTemp = this.isUpdate && this.tmp == 1;
      if (this.$route.query.work_order_id) {
        params['work_order_id'] = this.$route.query.work_order_id;
      }
      const url = isUpdateTemp
        ? apiEndpoints.work_order_update(this.projectId, this.workOrderId)
        : apiEndpoints.work_order_create(this.projectId); // WorkOrderController->store
      const {status, data, code} = await this.$http.post(url, params);

      if (status) {
        if (data.result.contract_warning) {
          return this.$swal.fire({
            icon: "error",
            html: data.result.message,
            width: data.result.width_alert || '70em',
          });
        }

        this.successToast(cfMessage.success, false, 3000);
        this.$router.push({
          name: 'projects.sales',
          query: {
            activeTabIndex: this.$constant.pages.project.sales.instruction.tabIndex
          }
        })
        return;
      }
      if (this.$helpers.isDisplayFormError(code)) {
        this.errors = data.errors;
        return this.$nextTick(() => {
          this.scrollIntoError();
        });
      } else if (this.$helpers.isDisplayErrorInLocalComponent(code)) {
        return this.errorToast(data.message);
      }
    },
    scrollIntoError() {
      const el = document.querySelector(".error-message");
      el.scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
    },
    backToList() {
      if (this.$route.params?.previousRoute?.fullPath) {
        return this.$router.push({
          path: this.$route.params.previousRoute.fullPath
        });
      }
      let query = (localStorage.getItem('projects/sales/instruction') == null)
        ? {activeTabIndex: this.$constant.pages.project.sales.instruction.tabIndex}
        : JSON.parse(localStorage.getItem('projects/sales/instruction'))
      this.$router.push({
        name: "projects.sales",
        params: {id: this.projectId},
        query: query
      });
    },
    updateFiles(data) {
      this.$set(this.form, "files", data);
    },
    reRenderModal(key) {
      this[key]++;
    },
    onClickRemoveWasteOrService(item) {
      const index = this.form.wastes_or_services_by_work_order.findIndex(
        (wasteOrService) => wasteOrService.cd === item.cd
      );
      if (index > -1) {
        this.form.wastes_or_services_by_work_order.splice(index, 1);
      }

      this.reRenderModal('key_wastes_or_services')
    },
    setMinNumber(e) {
      if (e.target.value < 0) this.form[e.target.id] = 0;
    },
    setUserApproval(user, item) {
      this.form.user_approval = item
      this.user_approval = user;
    },
    onRemoveTransportContract() {
      const currentContractsByWorkOrder = [...this.form.contracts_by_work_order];
      let index = currentContractsByWorkOrder.findIndex(contract => !!contract.transport_contract_cd)
      if(index > -1){
        currentContractsByWorkOrder.splice(index, 1)
      }

      this.$set(this.form, "contracts_by_work_order", [...currentContractsByWorkOrder]);
    },
    onRemoveTreatmentContract() {
      const currentContractsByWorkOrder = [...this.form.contracts_by_work_order];
      let index = currentContractsByWorkOrder.findIndex(contract => !!contract.treatment_contract_cd)
      if(index > -1){
        currentContractsByWorkOrder.splice(index, 1);
      }
      this.$set(this.form, "contracts_by_work_order", [...currentContractsByWorkOrder]);
    },
    formatHour(hour) {
      const splitHour = hour.toString().split(".");
      let value = ''
      if (splitHour[0] != undefined && splitHour[0] != 0) {
        value +=  splitHour[0] + '時間'
      }
      if (hour%1 != 0) {
        value +=  (hour%1 * 60)  + '分'
      }

      return value;
    },
    disableBtnSubmit(action) {
      if (this.readonlyQuery) return true;
      if (this.draft) return false;
      let isWorkFlowNew = this.form.latest_history_submitter && this.form.latest_history_submitter.user_id_created_by == this.user.id && this.tmp == 0
      if (action == this.$constant.workflowStatus.submit && (!this.isUpdate || isWorkFlowNew)) {
        return false
      }
      return !(Object.keys(this.role).length > 0 && this.role[action]);
    },
    getErrorUserApproval() {
      return this.errors['user_approval'] ? this.errors['user_approval'].toString() :
        (this.errors['user_approval.user_name'].toString() ? this.errors['user_approval.user_name'] : '');
    },
    isDeleteDisable(item){
      // このサービス廃棄物のidがreservedIdsに含まれている場合、削除不可
      return this.reservedIds.includes(item.pivot_id);
    },
    openworkHistoryModal() {
      this.$refs.workHistory.openModal(this.form.id, this.form.name);
    },
    /**
     * 利用停止および利用再開
     */
    async doNotInUse(){
      this.isLoading = true;
      let params = {
        notInUse : !this.form.not_in_use,
      }
      const url = apiEndpoints.projects_sales_work_order_not_in_use(this.projectId, this.workOrderId); // WorkOrderController->doNotInUse
      const {status, data, code} = await this.$http.post(url, params);
      if (status) {
        this.form.not_in_use = data.result.work_order.not_in_use;
      }
      this.isLoading = false;
    }
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    fullURL() {
      return `${window.location.protocol}//${window.location.host}${this.$route.path}`;
    },
    projectId() {
      return this.$route.params.id;
    },
    tmp() {
      return this.$route.query.tmp !== undefined && this.$route.query.tmp;
    },
    draft() {
      return this.$route.query.draft !== undefined && this.$route.query.draft;
    },
    copy() {
      return this.$route.query.copy !== undefined && this.$route.query.copy;
    },
    dailyReportId() {
      return this.$route.query.daily_report_id !== undefined && this.$route.query.daily_report_id;
    },
    zzCheckUpWorkItems() {
      return this.$store.getters['options/options_tables'].zz_checkup_work_items ?? [];
    },
    zzManifestPreparationRoles() {
      return this.$store.getters['options/options_tables'].zz_manifest_preparation_roles ?? [];
    },
    zzManifestTypes() {
      return this.$store.getters['options/options_tables'].zz_manifest_types ?? [];
    },
    zzMeasurementSites() {
      return this.$store.getters['options/options_tables'].zz_measurement_sites ?? [];
    },
    zzJwUnits() {
      const jwUnits = this.$store.getters['options/options_tables'].zz_jw_units ?? [];

      return jwUnits.filter(item => {
        const disableJwUnits = this.$constant.disable_zz_jw_units_create_work_order[this.form.zz_work_order_type_id]
          ?? this.$constant.default_disable_zz_jw_units_create_work_order;

        return !disableJwUnits.includes(item.id)
      });
    },
    zzJwQuantityConfirmationCompanyTypes() {
      return this.$store.getters['options/options_tables'].zz_jw_quantity_confirmation_company_types ?? [];
    },
    mixedLoadings() {
      const stageOption = this.$store.getters['options/options_tables'].zz_mixed_loading ?? [];
      return stageOption.map(obj => ({
        text: obj.mixed_loading,
        value: parseInt(obj.id)
      }));
    },
    reservationRentalContainers() {
      return [
        {text: "あり", value: 1},
        {text: "なし", value: 0}
      ];
    },
    workOrderType() {
      const workOrderTypes = this.$store.getters['options/options_tables'].zz_work_order_types ?? [];
      if (!workOrderTypes || !workOrderTypes.length) return '';

      if (this.$route.query.type) {
        return workOrderTypes.find(item => item.id == this.$route.query.type)?.work_order_type ?? '';
      }

      if (this.form.zz_work_order_type_id) {
        return workOrderTypes.find(item => item.id == this.form.zz_work_order_type_id)?.work_order_type ?? '';
      }

      return '';
    },
    workOrderTypeObject() {
      const workOrderTypes = this.$store.getters['options/options_tables'].zz_work_order_types ?? [];
      if (!workOrderTypes || !workOrderTypes.length) return '';

      if (this.$route.query.type) {
        return workOrderTypes.find(item => item.id == this.$route.query.type) ?? {};
      }

      if (this.form.zz_work_order_type_id) {
        return workOrderTypes.find(item => item.id == this.form.zz_work_order_type_id) ?? {};
      }

      return {};
    },
    workOrderId() {
      return this.$route.params.work_order_id ?? null;
    },
    isUpdate() {
      return !!this.workOrderId;
    },
    /**
     * 下書き保存可能かどうか
     */
    canDraft(){
      // 新規もしくはコピーの場合、または下書きの編集中
      return (this.copy || !this.workOrderId || this.draft); 
    },
    /**
     * 利用停止ボタンの表示非表示
     */
    showNotInUseButton(){
      // いわゆる更新申請画面のみ表示とする
      return (this.$route.query.work_order_id && !this.tmp && !this.copy && !this.draft);
      //return true;
    },
    isNotInUse(){
      return this.form.not_in_use == 1 ? true: false;
    },
    transportContract() {
      return this.form.contracts_by_work_order.find(contract => !!contract.transport_contract_cd)
    },
    transportContractVendors() {
      let id = this.form.contracts_by_work_order.find(contract => !!contract.transport_contract_cd)?.id
      return this.projectInfos?.transport_contracts.find(transport => transport.id == id);
    },
    treatmentContract() {
      return this.form.contracts_by_work_order.find(contract => !!contract.treatment_contract_cd)
    },
    wastesOrServicesByWorkOrder() {
      return this.form.wastes_or_services_by_work_order;
    },
    generateOptionsHour() {
      let minutes = 0;
      let options = [];
      for (let i = 0; i < 61; i++) {
        options.push(
          {value: (minutes/60).toFixed(2), text: this.formatHour(minutes/60)?this.formatHour(minutes/60):'0分'}
        )
        if(i<48){
          minutes += 15
        }else{
          minutes += 60
        }
      }
      return options
    },
    readonly() {
      return this.readonlyQuery || this.disableBtnSubmit(this.$constant.workflowStatus.submit)
    },
    readonlyQuery() {
      return this.$route.query.readonly === 'true' || this.$route.query.readonly === true
    },
    readonlyUserApprove() {
      let isSubmitRole = ! this.disableBtnSubmit(this.$constant.workflowStatus.submit)
      let isApproveRole = Object.keys(this.role).length > 0 && this.role[this.$constant.workflowStatus.approve]
      return ! (isSubmitRole || isApproveRole);
    },
    roleSubmit() {
      return ! this.disableBtnSubmit(this.$constant.workflowStatus.submit)
    },
    submitter() {
      return this.role.submitter != undefined ? this.role.submitter : null
    },
    notInUseLabel(){
      return this.form.not_in_use ? '利用再開' : '利用停止';
    },
    workOrderFlowHistoryHeaders() {
      return [
      {
          text: "申請者",
          sortable: false
        },
        {
          text: "承認者",
          sortable: false
        },
        {
          text: "承認依頼日",
          sortable: false
        },
        {
          text: "処理",
          sortable: false
        },
        {
          text: "コメント",
          width: 60,
          sortable: false
        },
      ]
    }
  },
  watch: {
    'form.standard_working_hours': {
      handler: function (val) {
        this.onCalculateTotalTime()
      },
    },
    'form.standard_travel_hours': {
      handler: function (val) {
        this.onCalculateTotalTime()
      },
    },
    'form.standard_unloading_hours': {
      handler: function (val) {
        this.onCalculateTotalTime()
      },
    },
  }
}
</script>

<template>
  <Layout>
    <ModalWorkHistory
      ref="workHistory"
    />
    <div class="scroll-area">
      <b-card class="mb-1">
        <ProjectInfo :data="projectInfos" @redirectBackToList="backToList()"/>
      </b-card>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <div class="work-instruction">
            <div class="job-info mb-2">作業情報</div>
            <div v-if="this.isCantApprove" class="alert alert-danger">
              <i class="mdi mdi-block-helper me-2"></i>
              既に予約に利用されているサービス・廃棄物を削除する更新申請です。承認することはできません。
            </div>
            <div class="mb-2">
              <h4>
                <WorkOrderTypeBadge :work-order-type="workOrderTypeObject" />
              </h4>
            </div>
            <div v-if="errors['zz_work_order_type_id']" class="error-message">
              {{ errors['zz_work_order_type_id'][0] }}
            </div>
            <b-row class="mt-2">
              <div class="input-group mb-3">
                <span class="input-group-text" id="work_orders_name_label">作業指示名</span>
                <input
                  type="text"
                  class="form-control"
                  id="work_orders_name"
                  :readonly="readonly"
                  v-model="form.name"
                  aria-describedby="work_orders_name_label"
                >
              </div>
              <div v-if="errors['name']" class="error-message">
                {{ errors['name'][0] }}
              </div>
            </b-row>
            <div class="row mt-2">
              <SelectTransportContractModal
                :work_order_type="form.zz_work_order_type_id"
                :contract="transportContract"
                @dataSelected="onChangeTransportContract"
                :disabled="readonly"
              />
              <TransportContracts
                @removeContract="onRemoveTransportContract"
                :transport-contract="transportContract"
                :disabled="readonly"
              />
              <div v-if="errors['contracts_by_work_order'] && errors['contracts_by_work_order'][0].startsWith('収集運搬')" class="error-message">
                {{ errors['contracts_by_work_order'][0] }}
              </div>
            </div>
            <div class="row mt-2">
              <SelectTreatmentContractModal
                :work_order_type="form.zz_work_order_type_id"
                :contract="treatmentContract"
                @dataSelected="onChangeTreatmentContract"
                :disabled="readonly"
              />
              <TreatmentContracts
                @removeContract="onRemoveTreatmentContract"
                :treatment-contract="treatmentContract"
                :disabled="readonly"
              />
              <div v-if="errors['contracts_by_work_order'] && errors['contracts_by_work_order'][0].startsWith('処分')" class="error-message">
                {{ errors['contracts_by_work_order'][0] }}
              </div>
            </div>
            <b-row>
              <div class="mt-2">
                <ChooseWasteOrServiceModal
                  v-if="dataLoaded"
                  :disabled="readonly"
                  :contracts="form.contracts_by_work_order"
                  :is-update="isUpdate"
                  :work-order-type-id="form.zz_work_order_type_id"
                  :case-id="Number(this.projectId)"
                  @dataSelected="onChangeWastesOrServices"
                  :wastes-or-services-by-work-order="wastesOrServicesByWorkOrder"
                  :key="`wastes_or_services_${key_wastes_or_services}`"
                  @modalHidden="reRenderModal"
                />
                <button
                  v-else
                  class="btn btn-primary waves-effect waves-light mb-2"
                  disabled
                >
                  <i class='far fa-list-alt'></i> 廃棄物・サービスを選択する
                </button>
                <CommonTableComponent :height-class="`table-wrapper-500`">
                  <thead class="table-light">
                  <tr>
                    <th>HK/SG管理番号</th>
                    <th>名称</th>
                    <th>廃棄物種類</th>
                    <th>運搬先</th>
                    <th>処分方法</th>
                    <th>マニフェスト</th>
                    <th>分類</th>
                    <th>計量</th>
                    <th>数量確定方法</th>
                    <th>数量確定者</th>
                    <th class="text-center">予約時<br>表示</th>
                    <th v-if="!readonly"></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, index) in wastesOrServicesByWorkOrder" :key="`wastesOrServicesByWorkOrder_${index}`">
                    <td>{{ item.cd }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.waste_category_name }}</td>
                    <td>{{ item.vendor_name }}</td>
                    <td>{{ item.treatment_method }}</td>
                    <td>
                      <b-form-select
                        v-if="item.waste_category_name"
                        text-field="manifest_preparation_role"
                        value-field="id"
                        class="form-select form-select-sm"
                        v-model="item.zz_manifest_preparation_role_id"
                        size="sm"
                        :options="zzManifestPreparationRoles"
                        :disabled="readonly"
                      ></b-form-select>
                    </td>
                    <td>
                      <b-form-select
                        v-if="item.waste_category_name"
                        class="form-select form-select-sm"
                        text-field="manifest_type"
                        value-field="id"
                        v-model="item.zz_manifest_type_id"
                        size="sm"
                        :options="zzManifestTypes"
                        :disabled="readonly"
                      ></b-form-select>
                    </td>
                    <td>
                      <b-form-select
                        v-if="item.waste_category_name"
                        class="form-select form-select-sm"
                        text-field="measurement_site"
                        value-field="id"
                        v-model="item.zz_measurement_site_id"
                        size="sm"
                        :options="zzMeasurementSites"
                        :disabled="readonly"
                      ></b-form-select>
                    </td>
                    <td>
                      <b-form-select
                        v-if="item.waste_category_name"
                        class="form-select form-select-sm"
                        text-field="jw_unit"
                        value-field="id"
                        v-model="item.zz_quantity_confirmation_unit_id"
                        size="sm"
                        :options="zzJwUnits"
                        :disabled="readonly"
                      ></b-form-select>
                    </td>
                    <td>
                      <b-form-select
                        v-if="item.waste_category_name"
                        class="form-select form-select-sm"
                        text-field="jw_quantity_confirmation_company_type"
                        value-field="id"
                        v-model="item.zz_jw_quantity_confirmation_company_type_id"
                        size="sm"
                        :options="zzJwQuantityConfirmationCompanyTypes"
                        :disabled="readonly"
                      ></b-form-select>
                    </td>
                    <td class="text-center">
                      <b-form-checkbox
                        value="1"
                        v-model="item.is_reservation_showing_to_discharger"
                        :disabled="readonly"
                      />
                    </td>
                    <td class="text-center" v-if="!readonly">
                      <b-button
                        class="btn-custom-red"
                        @click="onClickRemoveWasteOrService(item)"
                        :disabled="isDeleteDisable(item)"
                      >
                        <i class="fas fa-eraser"></i> 削除
                      </b-button>
                    </td>
                  </tr>
                  </tbody>
                </CommonTableComponent>
              </div>
              <div v-if="errors['wastes_or_services_by_work_order']" class="error-message">
                {{ errors['wastes_or_services_by_work_order'][0] }}
              </div>
            </b-row>
            <b-row class="mt-2">
              <b-col :cols="detectMobileDevice() ? 12 : 6" style="padding: 0;">
                <div class="wrapC">
                  <div class="labelC">営業担当者</div>
                  <div class="contentC">{{ projectInfos && projectInfos.discharger_site && projectInfos.discharger_site.user1 && projectInfos.discharger_site.user1.user_name }}</div>
                </div>
              </b-col>
              <b-col :cols="detectMobileDevice() ? 12 : 6" style="padding: 0;">
                <div class="wrapC">
                  <div class="labelC">現場担当者</div>
                  <div class="contentC">{{ projectInfos && projectInfos.discharger_site.discharger_site_person_in_charge }}</div>
                </div>
              </b-col>
              <b-col :cols="detectMobileDevice() ? 12 : 6">
                <div class="wrapC">
                  <div class="labelC">連絡先</div>
                  <div class="contentC">{{ projectInfos && projectInfos.discharger_site.tel }}</div>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <div :class="detectMobileDevice() ? '' : 'custom-checkbox-core'">
                <label for="checkbox-group-checkitems">確認項目</label>
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-checkbox-group
                    id="checkbox-group-checkitems"
                    class="d-flex gap-3"
                    v-model="form.checklists_by_work_order"
                    :options="zzCheckUpWorkItems"
                    :aria-describedby="ariaDescribedby"
                    name="checkbox-group-checkitems"
                    text-field="checkup_work_item"
                    value-field="id"
                    :disabled="readonly"
                  ></b-form-checkbox-group>
                </b-form-group>
              </div>
              <div v-if="errors['checklists_by_work_order']" class="error-message">
                {{ errors['checklists_by_work_order'][0] }}
              </div>
            </b-row>
            <b-row class="mt-2 mb-2">
              <b-col :cols=" detectMobileDevice() ? 6 : 2">
                <div class="input-group mb-1">
                  <span class="input-group-text">作業人数</span>
                  <input
                    type="number"
                    min="0"
                    id="number_of_staffs_delivered"
                    class="form-control"
                    v-model="form.number_of_staffs_delivered"
                    :readonly="readonly"
                    @keyup="setMinNumber($event)"
                  >
                  <span class="input-group-text">名</span>
                </div>
              </b-col>
              <div v-if="errors['number_of_staffs_delivered']" class="error-message">
                {{ errors['number_of_staffs_delivered'][0] }}
              </div>
            </b-row>
            <b-row>
              <ChooseQualificationModal
                :isUpdate="isUpdate"
                :id="workOrderId"
                :qualifications_by_work_order="form.qualifications_by_work_order"
                @dataSelected="onChangeDataQualification"
                :key="`qualifications_${key_qualifications}`"
                @modalHidden="reRenderModal"
                :disabled="readonly"
              />
              <div class="d-flex w-100 gap-2 flex-wrap">
                <h4 v-for="(item, index) in form.qualifications_by_work_order"
                    :key="`qualifications_by_work_order${index}`">
                  <span class="badge bg-success">{{ item.qualification }}×{{ item.number_of_staffs }}</span>
                </h4>
              </div>
              <div v-if="errors['qualifications_by_work_order']" class="error-message">
                {{ errors['qualifications_by_work_order'][0] }}
              </div>
            </b-row>
            <b-row class="mt-2">
              <ChooseImplementByFacilityModal
                :form="form"
                @changeData="onChangeDataImplements"
                :key="`implements_${key_implements}`"
                @modalHidden="reRenderModal"
                :disabled="readonly"
              />
              <div class="d-flex w-100 gap-2 flex-wrap">
                <h4 v-for="(item, index) in form.implements_by_work_order" :key="`implements_by_work_order_${index}`">
                  <span class="badge bg-success">{{ item.implement }}×{{ item.number_of_implements }}</span>
                </h4>
              </div>
              <div v-if="errors['implements_by_work_order']" class="error-message">
                {{ errors['implements_by_work_order'][0] }}
              </div>
            </b-row>
            <b-row class="mt-2">
              <div class="custom-textarea gap-2">
                <label for="rental_and_special_items_comment">レンタル品・特殊準備物</label>
                <ckeditor
                  :editor="ckeditorOptions.editor"
                  :disabled="readonly"
                  v-model="form.rental_and_special_items_comment"
                  :config="ckeditorOptions.editorConfig"></ckeditor>
              </div>
              <div v-if="errors['rental_and_special_items_comment']" class="error-message">
                {{ errors['rental_and_special_items_comment'][0] }}
              </div>
            </b-row>
            <b-row class="mt-2">
              <div class="custom-textarea gap-2">
                <label for="work_detail_and_safety_measure_comment">作業詳細・安全対策指示</label>
                <ckeditor
                  :editor="ckeditorOptions.editor"
                  :disabled="readonly"
                  v-model="form.work_detail_and_safety_measure_comment"
                  :config="ckeditorOptions.editorConfig"></ckeditor>
              </div>
              
              <div v-if="errors['work_detail_and_safety_measure_comment']" class="error-message">
                {{ errors['work_detail_and_safety_measure_comment'][0] }}
              </div>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <div class="input-group mb-1">
                  <span class="input-group-text">物品販売</span>
                  <input
                    type="text"
                    id="good_sales"
                    class="form-control"
                    v-model="form.product_sales_comment"
                    :readonly="readonly"
                  >
                </div>
              </b-col>
              <div v-if="errors['product_sales_comment']" class="error-message">
                {{ errors['product_sales_comment'][0] }}
              </div>
            </b-row>
            <b-row class="mt-2">
              <SelectVehicleModal
                :car_types_by_work_order="form.car_types_by_work_order"
                @dataSelected="onChangeCars"
                :key="`cars_${key_cars}`"
                @modalHidden="reRenderModal"
                :disabled="readonly"
              />
              <div class="d-flex w-100 gap-2 flex-wrap">
                <h4 v-for="(item, index) in form.car_types_by_work_order" :key="`car_types_by_work_order${index}`">
                  <span class="badge bg-success">{{ item.estimate_cd }}:{{
                      item.invoice_product_name
                    }}×{{ item.number_of_cars }}</span>
                </h4>
              </div>
              <div v-if="errors['car_types_by_work_order']" class="error-message">
                {{ errors['car_types_by_work_order'][0] }}
              </div>
            </b-row>
            <b-row class="mt-2 standard">
              <b-col :cols=" detectMobileDevice() ? 12 : 3">
                <div class="input-group mb-1">
                  <span class="input-group-text">標準作業時間</span>
                  <b-form-select
                    :disabled="readonly"
                    id="standard_working_hours"
                    v-model="form.standard_working_hours"
                    :options="generateOptionsHour"
                    :readonly="readonly"
                    class="form-select"
                  ></b-form-select>
                </div>
                <div v-if="errors['standard_working_hours']" class="error-message">
                  {{ errors['standard_working_hours'][0] }}
                </div>
              </b-col>
              <b-col :cols=" detectMobileDevice() ? 12 : 3">
                <div class="input-group mb-1">
                  <span class="input-group-text">標準移動時間（往復）</span>
                  <b-form-select
                    :disabled="readonly"
                    v-model="form.standard_travel_hours"
                    :options="generateOptionsHour"
                    class="form-select"
                    id="standard_travel_hours"
                    :readonly="readonly"
                  ></b-form-select>
                </div>
                <div v-if="errors['standard_travel_hours']" class="error-message">
                  {{ errors['standard_travel_hours'][0] }}
                </div>
              </b-col>
              <b-col :cols=" detectMobileDevice() ? 12 : 3">
                <div class="input-group mb-1">
                  <span class="input-group-text">標準荷卸時間</span>
                  <b-form-select
                    :disabled="readonly"
                    v-model="form.standard_unloading_hours"
                    :options="generateOptionsHour"
                    class="form-select"
                    id="standard_unloading_hours"
                    :readonly="readonly"
                  ></b-form-select>
                </div>
                <div v-if="errors['standard_unloading_hours']" class="error-message">
                  {{ errors['standard_unloading_hours'][0] }}
                </div>
              </b-col>
              <b-col :cols=" detectMobileDevice() ? 12 : 3">
                <div class="input-group mb-1">
                  <span class="input-group-text">標準合計時間</span>
                  <b-form-input
                    id="standard_total_hours"
                    :value="formatHour(form.standard_total_hours)"
                    readonly
                  ></b-form-input>
                </div>
                <div v-if="errors['standard_total_hours']" class="error-message">
                  {{ errors['standard_total_hours'][0] }}
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-3 transport-contracts gap-3">
              <ContractVendorsInfo :transport-contract-vendors="transportContractVendors" :disabled="readonly"/>
            </b-row>
            <b-row class="mt-3" :class="detectMobileDevice() ? 'gap-2': ''">
              <b-col cols="3" class="d-flex align-items-center col-md-3 col-12">
                <div class="custom-radio-group">
                  <label class="label-group" for="mixed_loading_kbn"
                  >単独・合積</label
                  >
                  <b-form-radio-group
                    class="radio-group"
                    id="mixed_loading_kbn"
                    v-model="form.mixed_loading_kbn"
                    :options="mixedLoadings"
                    name="mixedLoading-options"
                    :disabled="readonly"
                  ></b-form-radio-group>
                </div>
              </b-col>
              <b-col cols="3" class="d-flex align-items-center col-md-3 col-12">
                <div class="custom-radio-group">
                  <label class="label-group" for="is_reservation_rental_containers"
                  >空容器</label
                  >
                  <b-form-radio-group
                    class="radio-group"
                    id="is_reservation_rental_containers"
                    v-model="form.is_reservation_rental_containers"
                    :options="reservationRentalContainers"
                    name="reservationRentalContainers-options"
                    :disabled="readonly"
                  ></b-form-radio-group>
                </div>
              </b-col>
              <b-col cols="3" class="col-md-3 col-12">
                <div class="custom-datepicker gap-2">
                  <label for="planned_start_date">初回予定日</label>
                  <b-form-input
                    :disabled="readonly"
                    v-model="form.planned_start_date"
                    position="left"
                  ></b-form-input>
                </div>
                <div v-if="errors['planned_start_date']" class="error-message">
                  {{ errors['planned_start_date'][0] }}
                </div>
              </b-col>
            </b-row>
            <b-row v-if="errors['is_reservation_rental_containers']">
              <b-col cols="3"></b-col>
              <b-col cols="3">
                <div class="error-message">
                  {{ errors['is_reservation_rental_containers'][0] }}
                </div></b-col>
              <b-col cols="3"></b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <div class="input-group">
                  <span class="input-group-text">備考</span>
                  <textarea rows="4" max-rows="6" v-model="form.remarks" class="form-control"></textarea>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <DropZoneModal
                @uploadSelected="updateFiles"
                :isUpdate="isUpdate"
                :files="form.files"
                :key="`key_files_${key_files}`"
                :disabled="readonly"
              />
              <b-col cols="10">
                <div>
                  <div class="attachment-files-wrapper">
                    <AttachmentFiles
                      v-if="form.files.length"
                      :files="form.files"
                    />
                    <div v-else>添付されているファイルはありません</div>
                  </div>
                </div>
                <div v-if="errors['files']" class="error-message">
                  {{ errors['files'][0] }}
                </div>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
      <b-card v-if="data && data.workflow_histories">
        <b-row>
          <CommonTableComponent :height-class="`table-wrapper-500`">
            <thead class="table-light">
            <tr>
              <th
                v-for="(item, index) in workOrderFlowHistoryHeaders"
                :key="index"
                :class="getHeaderClass(item)"
              >
                  <span v-if="item.sortable" @click="clickSort(item.value)">
                    {{ item.text }}
                    <i :class="getSortClass(item.value)"></i>
                  </span>
                <span v-else>
                    {{ item.text }}
                  </span>
              </th>
            </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in data.workflow_histories"
                :key="index"
              >
              <td>{{ item.user_created_by && item.user_created_by.user_name }}</td>
              <td>{{ item.user && item.user.user_name }}</td>
              <td>{{ item.submit_date|longDate }}</td>
                <td>{{ item.workflow_status && item.workflow_status.workflow_status }}</td>
                <td>{{ item.comment }}</td>
              </tr>
            </tbody>
          </CommonTableComponent>
        </b-row>
      </b-card>
    </div>
    <div class="button-fixed-custom">
      <b-row>
        <b-col cols="12" class="d-flex justify-content-between gap-4" :class="detectMobileDevice() ? 'flex-wrap' : ''">
          <div :class="detectMobileDevice() ? 'col-4' : 'btn-custom-width'">
            <button class="btn btn-primary waves-effect waves-light" @click="backToList()">
              <i class='far fa-arrow-alt-circle-left'></i> {{ this.$lang.button.back }}
            </button>
          </div>
          <div :class="detectMobileDevice() ? 'col-8' : ''" style="width: 100%">
            <div>
              <div class="d-flex gap-2">
                <b-form-textarea
                  id="comment"
                  v-model="form.comment"
                  placeholder="コメント"
                  style="height: 10px"
                  :disabled="readonlyQuery"
                ></b-form-textarea>
              </div>
              <div v-if="errors['comment']" class="error-message">
                {{ errors['comment'][0] }}
              </div>
            </div>
            <div class="mt-2">
                <div class="custom-input gap-2">
                  <button 
                    :class="{'btn-outline-warning': isNotInUse,'btn-warning': !isNotInUse}" 
                    class="btn w-md waves-effect waves-light me-2" 
                    @click="doNotInUse()"
                    v-if="showNotInUseButton"
                    >
                      {{ notInUseLabel }}
                  </button>
                  <label for="" class="text-nowrap">事業者メールアドレス</label>
                  <b-form-input
                    :disabled="readonlyQuery"
                    v-model="form.discharger_site_user_email"
                    type="email"
                  ></b-form-input>
                </div>
              <div v-if="errors['discharger_site_user_email']" class="error-message">
                {{ errors['discharger_site_user_email'][0] }}
              </div>
            </div>
          </div>
          <div :class="detectMobileDevice() ? 'col-12' : ''" style="width: 100%">
            <div class="btn-group-status mb-2">
              <button :class="detectMobileDevice() ? 'mb-2' : ''" class="btn btn-primary w-md waves-effect waves-light me-2" @click="submit($constant.workflowStatus.submit)" :disabled="disableBtnSubmit(this.$constant.workflowStatus.submit)" v-if="canUserEdit()">申請</button>
              <button v-if="!canDraft" :class="detectMobileDevice() ? 'mb-2' : ''" class="btn btn-primary w-md waves-effect waves-light me-2" @click="submit($constant.workflowStatus.back_before_approved)" :disabled="disableBtnSubmit(this.$constant.workflowStatus.back_before_approved)">取消</button>
              <button v-if="!canDraft" :class="detectMobileDevice() ? 'mb-2' : ''" class="btn btn-primary w-md waves-effect waves-light me-2" @click="submit($constant.workflowStatus.approve)" :disabled="disableBtnSubmit(this.$constant.workflowStatus.approve) || this.isCantApprove">承認</button>
              <button v-if="!canDraft" class="btn btn-primary w-md waves-effect waves-light me-2" @click="submit($constant.workflowStatus.back_submit)" :disabled="disableBtnSubmit(this.$constant.workflowStatus.back_submit)">差戻</button>
              <button v-if="!canDraft" class="btn btn-wo-delete w-md waves-effect waves-light me-2" @click="submit($constant.workflowStatus.clear)" :disabled="disableBtnSubmit(this.$constant.workflowStatus.clear)">申請削除</button>
              <button v-if="canDraft" class="btn btn-warning w-md waves-effect waves-light me-2" @click="submit($constant.workflowStatus.draft)">下書き保存</button>
              <button v-if="canDraft && draft" class="btn btn-danger w-md waves-effect waves-light me-2" @click="confirmDraftDelete()">下書き削除</button>
              <button v-if="form.id && !canDraft"
                @click="openworkHistoryModal()"
                class="btn btn-primary w-md waves-effect waves-light"
              >
                <i class="fas fa-history"></i> 作業履歴
              </button>

            </div>
            <SearchDataUserModal
              :disabled="readonlyUserApprove || readonlyQuery"
              :data-search="{
                user: user_approval,
              }"
              :role-submit="roleSubmit"
              :submitter="submitter"
              @dataSelected="setUserApproval"
              :placeholder-txt="'申請または承認の場合は、次の承認者を選択してください'"
            />
            <div v-if="errors['user_approval'] || errors['user_approval.user_name']" class="error-message">
              {{ this.getErrorUserApproval() }}
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </Layout>
</template>
<style scoped lang="scss">
@media screen {
.scroll-area {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  overflow-x: hidden;
}
}
@media only print {
  button{
    display: none;
  }
}

.button-fixed-custom {
  position: sticky;
  bottom: 0;
  z-index: 10;
  margin-top: 10px;
  margin-bottom: -34px;
}
.work-instruction {
  margin: 16px 16px;
  font-size: 14px;
  gap: 16px;
  .job-info {
    font-size: 16px;
    font-weight: 600;
  }
  .contract-infos {
    gap: 20px;
  }
  .custom-checkbox-core {
    label {
      flex: 0 0 5%;
      align-self: center;
      margin-bottom: unset;
    }
  }
  .tool {
    .tool-label {
      padding-right: 20px;
    }
  }
  .custom-textarea {
    label {
      align-self: flex-start;
    }
  }
  .vehicles {
    display: flex;

    .label {
      flex: 0 0 100px;
    }

    &-table {
      width: 100%;
    }
  }
  .standard {
    .custom-input {
      label {
        flex: 1 0 auto;
      }
    }
  }
  .transports {
    .label {
      width: 100px;
    }

    .items {
      display: grid;
      gap: 10px;
      width: 100%;
    }
  }
  .transport-contracts {
    .custom-input {
      label {
        flex: 1 0 auto;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    #checkbox-group-checkitems {
      display: flex;
      flex-wrap: wrap;
      .custom-checkbox {
        display: flex;
      }
    }
    .standard {
      gap: 0.5rem;
    }
    .custom-input input {
      align-self: center;
      width: 100%;
    }

    .custom-input label {
      flex: unset;
      text-wrap: nowrap;
      margin-right: 5px;
    }

    .custom-textarea {
      flex-direction: column;
    }
    .custom-textarea label {
      flex: unset;
    }
    .btn-group-status {
      display: flex;
      flex-wrap: wrap;
      gap: 5px;
      button {
        margin-right: unset !important;
      }
    }
  }
}
.labelC {
  padding: 10px;
  white-space:nowrap;
  font-weight: bold;
}
.contentC {
  padding: 10px;
  background: #f8f9fa;
  width: 100%;
}
.wrapC {
  margin-bottom: 10px;
  display: flex;
  column-gap: 0.5rem !important;
}
.btn-custom-width {
  width: 10%;
}
.btn-wo-delete {
  color: #fff;
  background-color: #d33;
  border-color: #d33;
  box-shadow: 0 3px 1px darken(#d33,7.5%);
}
.btn-wo-delete:active {
    box-shadow: none;
    transform: translateY(2px);  
  }
</style>
